
$('.gallery-slider').slick({
   infinite: true,
   dots: true,
   variableWidth: true,
   arrows: true,
   slidesToShow: 4,
   appendDots: '.gallerySection .news-dots',
   appendArrows: '.gallerySection .news-dots',
   slidesToScroll: 2,
   prevArrow: '<button type="button" class="slick-prev"><svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M10.7071 19.3731C11.0976 18.9826 11.0976 18.3494 10.7071 17.9589L2.74755 9.99935L10.7071 2.03979C11.0976 1.64927 11.0976 1.0161 10.7071 0.625577C10.3166 0.235053 9.68342 0.235053 9.29289 0.625577L0.626227 9.29224C0.235703 9.68277 0.235703 10.3159 0.626227 10.7065L9.29289 19.3731C9.68342 19.7636 10.3166 19.7636 10.7071 19.3731Z" fill="#01002C"/>\n' +
      '</svg>\n</button>',
   nextArrow: '<button type="button" class="slick-next"><svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M0.292893 19.3731C-0.0976311 18.9826 -0.0976311 18.3494 0.292893 17.9589L8.25245 9.99935L0.292892 2.03979C-0.0976319 1.64927 -0.0976319 1.0161 0.292892 0.625577C0.683417 0.235053 1.31658 0.235053 1.70711 0.625577L10.3738 9.29224C10.7643 9.68277 10.7643 10.3159 10.3738 10.7065L1.70711 19.3731C1.31658 19.7636 0.683417 19.7636 0.292893 19.3731Z" fill="#01002C"/>\n' +
      '</svg>\n</button>',
   responsive: [
      {
         breakpoint: 991,
         settings: {
            infinite: true,
            dots: true,
            variableWidth: true,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1,
         }
      },

   ]
});

